import { Suspense } from "react";
import { Route } from "react-router-dom";
import Spinner from "../common/Spinner";
import ErrorBoundary from "../components/ErrorBoundary";

export interface RouteProperties {
    path: string;
    element: React.ComponentType<any>;
    children?: RouteProperties[];
}

export const renderRoutes = (route: RouteProperties) => {
    if (route) {
        return (
            <Route
                path={route.path}
                key={route.path}
                element={
                    <Suspense fallback={<Spinner />}>
                        <ErrorBoundary>
                            <route.element />
                        </ErrorBoundary>
                    </Suspense>
                }>
                {route?.children?.map((child) => renderRoutes(child))}
            </Route>
        );
    }
};
